<template>
	<div class="video-container flex-center">
		<main-header class="i-h"></main-header>
		<video play controls :src="url" v-if="url"></video>
		<div v-else>播放链接无效</div>
	</div>
</template>

<script>
	import mainHeader from '@/components/main-header/main-header'
	export default {
		name: '',
		props: {

		},
		components: {
			mainHeader
		},
		data() {
			return {
				url: ''
			}
		},
		created() {
			this.url = decodeURIComponent(this.$route.query.url)
		},
		mounted() {

		},
		methods: {

		}

	}
</script>

<style lang="scss" scoped>
	.video-container {
		width: 100vw;
		height: 100vh;
		display: flex;
		flex-direction: column;
		
		.i-h{
			width: 100%;
		}
		
		video {
			height: 0;
			flex-grow: 1;
			width: 100%;
			object-fit: none;
		}
	}
</style>